import { Injectable } from '@angular/core';
import { Query } from 'apollo-angular';
import gql from 'graphql-tag';
import { BarcodeItem, Relay } from '../../../../../../../common/interfaces/prisma.binding';

export interface Response {
  allBarcodes: BarcodeItem[];
}

@Injectable({
  providedIn: 'root',
})
export class AllBarcodesQuery extends Query<Response> {
  document = gql`
    query allBarcodes {
      barcodeItems {
        id
        ean
        userId
        metaData
        scannedDate
        barcodeItemType
        price
      }
    }
  `;
}
